import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Parser } from 'html-to-react';
import sh from '../../../../../helpers/string.helper';

const htmlToComponents = new Parser().parse;

const Blog = ({
  t,
  item,
  time,
  imgSrc,
  color,
}) => (
  <div className="BlogsBox BlogsBoxhover">
    <Link to={`/blog/post-${item.id}`}>
      <img
        src={imgSrc}
        alt="blog"
        className="img-responsive width img-blog"
        onError={(e) => { e.target.src = '/img/blog2.png'; }}
      />
      <div className={`bottom ${color || ''}`}>
        <h5 className="tc">{item.title}</h5>
        <div className="blog-sub">{item.content && htmlToComponents(sh.replaceSpecialChars(item.content).substring(0, 200))}</div>
        <h6>{item.creator}<span className="read-time">{`${time} ${t('Min read')}`}</span></h6>
      </div>
    </Link>
  </div>
);

Blog.propTypes = {
  t: PropTypes.func.isRequired,
};

export default Blog;



// WEBPACK FOOTER //
// ./src/views/modules/blog/blogPost/simple/BlogPost.jsx